// @ts-nocheck



import { createSlice } from '@reduxjs/toolkit';
import { journalApi } from '../lib/api';



export const FETCH_JOURNAL = 'vehicles/journal/fetch';



const initialState = null;

const journalSlice = createSlice({
  name: 'vehicles/journal',
  initialState,
  reducers: {
    fetch: (state, { payload }) => {
      return { ...payload };
    }
  }
});

export const journalActions = journalSlice.actions;

export const fetchJournal = (id) => async (dispatch) => {
  const journal = await journalApi.fetchJournal(id);
  dispatch(journalActions.fetch({ ...journal }));
};

export default journalSlice.reducer;